(function (root) {
  'use strict';
  function lookup(catalog, hardware) {
    var policy = catalog && catalog.hardwareCapabilities;
    var reference = typeof hardware === 'string' ? hardware : hardware && hardware.reference;
    var record = policy && policy.byReference && policy.byReference[reference];
    var profile = record && policy.profiles && policy.profiles[record.profile];
    var family = record && record.padFamily || null;
    var pads = family && policy.pads && policy.pads[family];
    var pistons = profile && Array.isArray(profile.allowedPistons) ? profile.allowedPistons.slice() : ['standard-aluminium'];
    if (record && record.excludeVentedAluminium) pistons = pistons.filter(function (value) { return value !== 'vented-aluminium'; });
    return {
      capabilityKnown: !!(record && profile),
      capabilityRevision: policy && policy.revision || null,
      capabilityProfile: record && record.profile || null,
      padFamilyReference: family,
      padReference: family,
      standardPadReference: family ? family + '-01' : null,
      allowedPistons: pistons,
      antiKnockbackSprings: !!(profile && profile.antiKnockbackSprings),
      allowedPadCompounds: pads && Array.isArray(pads.allowedCompounds) ? pads.allowedCompounds.slice() : ['street'],
      minimumWheelDiameterMm: record && Number.isFinite(record.minimumWheelDiameterMm) ? record.minimumWheelDiameterMm : null,
      nominalMinimumWheelInches: record && Number.isFinite(record.nominalMinimumWheelInches) ? record.nominalMinimumWheelInches : null
    };
  }
  function decorate(catalog, result) {
    if (!catalog || !catalog.hardwareCapabilities || catalog.hardwareCapabilities.enabled !== true) return result;
    var output = Object.assign({}, result, { hardware: {}, blockers: (result.blockers || []).slice() });
    Object.keys(result.hardware || {}).forEach(function (axle) {
      var original = result.hardware[axle];
      var capabilities = lookup(catalog, original);
      output.hardware[axle] = Object.assign({}, original, capabilities);
      // Missing factory references have the original generation blocker. An unexpected
      // resolved reference must not inherit unrestricted capabilities from its label.
      if (original.reference && !capabilities.capabilityKnown) {
        output.blockers.push({ axle: axle, code: 'missing_hardware_capability_policy', message: 'This hardware needs its option compatibility confirmed before ordering.' });
      }
    });
    output.orderableHardware = output.blockers.length === 0;
    return output;
  }
  function wheelAllowed(catalog,hardware,wheel){
    const rows=Object.values(hardware?.hardware||{});
    return rows.length>0&&rows.every(row=>{const cap=lookup(catalog,row),diameter=Number(row.diameter||String(row.reference||'').match(/-(\d+)X/i)?.[1]);const guide=([[286,15],[304,16],[330,17],[356,18],[380,19],[405,20],[430,21]].find(([max])=>diameter>0&&diameter<=max)||[])[1];const nominal=Math.max(cap.nominalMinimumWheelInches||0,guide||Infinity);return !!catalog.hardwareCapabilities?.byReference?.[row.reference]&&Number.isFinite(nominal)&&wheel>=nominal;});
  }
  root.CeikaHardwareCapabilities = Object.freeze({ lookup: lookup, decorate: decorate, wheelAllowed:wheelAllowed });
  if (typeof module !== 'undefined' && module.exports) module.exports = root.CeikaHardwareCapabilities;
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (root) {
  'use strict';
  var clone = function (value) { return value == null ? value : JSON.parse(JSON.stringify(value)); };
  var id = function (value) { return String(value || '').split('/').pop(); };
  var externalBoots = function (value) { return value === true || /external|with-dust|dust-boots/.test(String(value || '')); };
  function wantsBoots(selected, axle, mode) {
    if (Object.prototype.hasOwnProperty.call(selected, 'boots-' + axle)) return externalBoots(selected['boots-' + axle]);
    var value = selected[mode === 'Front + Rear' ? 'boots-both' : 'boots-single'];
    if (!externalBoots(value)) return false;
    if (/front-only/.test(String(value))) return axle === 'front';
    if (/rear-only/.test(String(value))) return axle === 'rear';
    return true;
  }
  function resolve(input) {
    var catalog = input.catalog || {}, selected = input.selected || {};
    var variant = input.variant || {}, requestedId = id(typeof variant === 'object' ? variant.id : variant);
    var canonicalId = (catalog.variantAliases || {})[requestedId] || requestedId;
    var base = typeof variant === 'object' ? variant : (catalog.baseVariants || []).find(function (v) { return id(v.id) === canonicalId; });
    if (!base || !base.mode) base = (catalog.baseVariants || []).find(function (v) { return id(v.id) === canonicalId; }) || {};
    var mapping = (catalog.factoryHardware || {})[canonicalId];
    var records = catalog.hardwareRecords || catalog.factoryHardwareRecords || {};
    var result = { canonicalVariantId: canonicalId, hardware: {}, blockers: [], axleBlockers: {}, compulsoryBootAxles: [], optionalBootAxles: [], selectedOptionalBootAxles: [], unavailableBootAxles: [], requiresHardwareConfirmation: [], rejectedRetainedSelections: [], aliasesNormalized: requestedId !== canonicalId, parkingChargeKey: null };
    function block(axle, code, message, alternatives) {
      var item = { code: code, axle: axle, message: message };
      if (alternatives) item.alternativeReferences = alternatives;
      result.blockers.push(item); (result.axleBlockers[axle] || (result.axleBlockers[axle] = [])).push(item);
    }
    if (!mapping) { block('configuration', 'missing_hardware_mapping', 'Select a kit with a mapped hardware specification.'); return result; }
    ['front', 'rear'].forEach(function (axle) {
      var original = mapping[axle];
      if (typeof original === 'string') original = (catalog.factorySingleBranches || {})[original];
      if (!original) return;
      var parkingArchitecture = catalog.parking?.architecture || catalog.vehicleProfile?.oemParkingType || 'electronic';
      var hardware = clone(original), parking = axle === 'rear' && input.parkingIncluded === true && parkingArchitecture !== 'drum_in_hat';
      var compulsory = original.dustChoice === 'compulsory';
      if (parking) {
        var parkingRef = original.parkingArchitecture === parkingArchitecture ? original.parkingReference : (parkingArchitecture === 'electronic' ? original.electronicParkingReference : null);
        if (!parkingRef || !records[parkingRef]) {
          block(axle, 'parking_hardware_unavailable', 'This rear caliper has no verified matching parking-brake hardware. Choose a supported rear caliper or contact CEIKA.', original.electronicParkingAlternatives || []);
        } else {
          hardware = Object.assign({}, hardware, clone(records[parkingRef]));
          hardware.sourceSpecificationBeforeParking = original.legacySpecification;
          hardware.referenceMappingBasis = 'same_existing_caliper_family_and_diameter_with_authoritative_EPB_dimensions';
          compulsory = true;
          result.parkingChargeKey = parkingArchitecture === 'integrated_disc' ? 'integrated_parking_mechanical' : 'integrated_parking_electronic';
        }
      }
      if (!parking && original.dustChoice === 'optional' && original.optionalDustReference && records[original.optionalDustReference]) {
        result.optionalBootAxles.push(axle);
        if (wantsBoots(selected, axle, base.mode)) {
          hardware = Object.assign({}, hardware, clone(records[original.optionalDustReference]));
          hardware.referenceMappingBasis = 'same_existing_caliper_family_dimensions_authoritative_dust_counterpart';
          result.selectedOptionalBootAxles.push(axle);
        }
      } else if (!compulsory && !parking) {
        result.unavailableBootAxles.push(axle);
        if (wantsBoots(selected, axle, base.mode)) result.rejectedRetainedSelections.push({ axle: axle, option: 'dust_boots', reason: 'no_authoritative_same_family_dust_counterpart' });
      }
      if (compulsory && !(result.axleBlockers[axle] || []).some(function (b) { return b.code === 'parking_hardware_unavailable'; })) result.compulsoryBootAxles.push(axle);
      if (!hardware.reference) {
        result.requiresHardwareConfirmation.push({ axle: axle, candidates: hardware.referenceCandidates || [] });
        block(axle, 'ambiguous_factory_generation', 'This caliper specification needs its exact factory reference confirmed before ordering.', hardware.referenceCandidates || []);
      }
      hardware.dustCompulsory = compulsory;
      hardware.dustSelected = compulsory || result.selectedOptionalBootAxles.indexOf(axle) >= 0;
      // The thresholds are physical constraints, independent of the availability data.
      hardware.rotorUpgradeMinimumPass = hardware.diameter >= 330 && hardware.thickness >= (axle === 'front' ? 32 : 28);
      hardware.floatingApproved = hardware.floatingApproved === true;
      hardware.waveSurfaces = Array.isArray(hardware.waveSurfaces) ? hardware.waveSurfaces.slice() : [];
      // A physical pad reference is separate from the commercial A-D price band.
      if (hardware.architecture === 'dual_feed_drift') {
        hardware.padFamily = null;
        hardware.padPriceBand = null;
        hardware.padBandStatus = 'dual_feed_pad_price_mapping_required';
      }
      result.hardware[axle] = hardware;
    });
    if (result.hardware.front && result.hardware.rear && result.hardware.rear.diameter > result.hardware.front.diameter) block('rear', 'rear_larger_than_front', 'The rear rotor must not be larger than the front rotor.');
    result.orderableHardware = result.blockers.length === 0;
    return result;
  }
  function resolveWithCapabilities(input) {
    var result = resolve(input);
    var enabled = input.catalog && input.catalog.hardwareCapabilities && input.catalog.hardwareCapabilities.enabled === true;
    if (!enabled) return result;
    if (!root.CeikaHardwareCapabilities) {
      result.blockers.push({ axle: 'configuration', code: 'capability_module_not_loaded', message: 'Option compatibility could not load. Refresh before continuing.' });
      result.orderableHardware = false;
      return result;
    }
    return root.CeikaHardwareCapabilities.decorate(input.catalog, result);
  }
  root.CeikaFactoryPolicy = Object.freeze({ resolve: resolveWithCapabilities });
  if (typeof module !== 'undefined' && module.exports) module.exports = root.CeikaFactoryPolicy;
})(typeof globalThis !== 'undefined' ? globalThis : this);

(function (global) {
  'use strict';
  class NativeOptions {
    constructor(catalog) {
      this.catalog = catalog;
      this.disabledUpgrades = new Set(catalog.policy?.disabledUpgrades || []);
      this.options = new Map(catalog.options.map(o => [o.key, o]));
      this.selected = {};
      this.dustRequired = false;
      this.dustSelectionPending = false;
      this.text = {};
      this.files = {};
      this.uploads = {};
      for (const o of catalog.options) {
        const initial = o.values.find(v => v.default);
        if (initial) this.selected[o.key] = initial.key;
      }
      this.parkingIncluded = catalog.parking.defaultIncluded;
      const first = catalog.baseVariants.find(v => NativeOptions.kitAllowed(catalog, v.id));
      if (!first) throw new Error('No kit configuration is enabled');
      this.setVariant(first.id);
    }
    setVariant(id) {
      const baseId = this.catalog.variantAliases[String(id)] || String(id);
      const variant = this.catalog.baseVariants.find(v => v.id === baseId);
      if (!variant) throw new Error('Unknown kit variant');
      if (!NativeOptions.kitAllowed(this.catalog, variant.id)) throw new Error('Kit configuration is disabled');
      this.variant = variant;
      this.syncDustChoice();
      this.resolveHardware();
      this.applyUpgradePrices();
      this.normalizeBoots();
      this.normalizeFinish();
      for (const o of this.catalog.options) {
        if (!this.visible(o.key)) continue;
        const value = o.values.find(v => v.key === this.selected[o.key]);
        if (value && !this.valueAllowed(o, value) && !(this.dustRequired && o.key.startsWith('boots-'))) {
          this.selected[o.key] = o.key === 'surface' ? undefined : o.values.find(v => v.default && this.valueAllowed(o, v))?.key;
        }
      }
      this.resolveHardware();
      this.applyUpgradePrices();
      this.normalizeFinish();
    }
    syncDustChoice() {
      if (!this.variant) return;
      const key = this.variant.mode === 'Front + Rear' ? 'boots-both' : 'boots-single';
      const option = this.options.get(key);
      const value = option?.values.find(v => v.key.startsWith('internal') !== this.dustRequired);
      if (value) this.selected[key] = value.key;
    }
    setDustRequired(required) {
      this.dustRequired = Boolean(required);
      this.syncDustChoice();
      this.resolveHardware();
      this.applyUpgradePrices();
      this.normalizeBoots();
    }
    resolveHardware() {
      if (!this.catalog.factoryPolicy?.enabled) { this.hardwareState = null; return; }
      if (!global.CeikaFactoryPolicy?.resolve) throw new Error('factory_policy_unavailable');
      this.hardwareState = global.CeikaFactoryPolicy.resolve({catalog:this.catalog,variant:this.variant,parkingIncluded:this.parkingIncluded,selected:this.selected});
      if (this.dustRequired && (!NativeOptions.dustCompatibleHardware(this.hardwareState) || this.dustSelectionPending)) {
        this.hardwareState.blockers.push({code:'dust_caliper_selection_required',message:'Select a caliper compatible with external dust boots.'});
        this.hardwareState.orderableHardware=false;
      }
      const rear = catalogRearAvailability(this.catalog);
      if(this.variant.mode !== 'Front Kit' && (rear.rearChoiceDisabled || rear.parkingChoiceDisabled)){
        this.hardwareState.blockers.push({code:'rear_availability_unconfirmed',message:rear.message || 'Confirm rear fitment with CEIKA before ordering'});
        this.hardwareState.orderableHardware=false;
      }
    }
    normalizeBoots() {
      if (!this.hardwareState) return;
      const axles = this.variant.mode === 'Front + Rear' ? ['front','rear'] : [this.variant.mode === 'Front Kit' ? 'front' : 'rear'];
      if (!axles.every(axle => this.hardwareState.compulsoryBootAxles?.includes(axle))) return;
      const option = this.options.get('boots-' + (axles.length === 2 ? 'both' : 'single'));
      const required = option?.values.find(value => !value.key.startsWith('internal'));
      if (required) this.selected[option.key] = required.key;
    }
    upgradeCategory(option, value) {
      const family = option.key.replace(/-(single|both|front|rear)$/, '');
      if (family === 'boots') return 'boots';
      if (family === 'pistons') return value.key.includes('stainless') ? 'stainless' : value.key.startsWith('vented-aluminium') ? 'vented' : null;
      if (family === 'springs' && value.key.startsWith('add')) return 'springs';
      if (family === 'pads') return value.key.startsWith('sport') ? 'padsSport' : value.key.startsWith('race') ? 'padsRace' : value.key.startsWith('pro-') ? 'padsPro' : null;
      return null;
    }
    applyUpgradePrices() {
      const pricing = this.catalog.upgradePricing;
      if (!pricing?.enabled) return;
      for (const option of this.catalog.options) for (const value of option.values) {
        const category = this.upgradeCategory(option, value);
        if (!category) continue;
        value.sourceLabel ??= value.label;
        value.dynamicPriceError = null;
        let amount = 0;
        const axles = this.affectedAxles(option,value);
        const selectedAxles = category === 'boots' && value.key.startsWith('internal') ? axles.filter(axle => this.hardwareState?.compulsoryBootAxles?.includes(axle)) : axles;
        for (const axle of selectedAxles) {
          const hardware = this.hardwareState?.hardware?.[axle];
          let rate;
          if (category.startsWith('pads')) rate = pricing.rates?.pads?.[this.catalog.hardwareCapabilities?.enabled ? hardware?.padFamilyReference : hardware?.padPriceBand || hardware?.padFamily]?.[category.slice(4).toLowerCase()];
          else rate = pricing.rates?.[category]?.[hardware?.pistons];
          if (!Number.isSafeInteger(rate) || rate < 0) { value.dynamicPriceError = 'upgrade_rate_missing'; break; }
          amount += rate;
        }
        if (category === 'boots' && selectedAxles.length === 0) {
          value.price = 0; value.chargeVariantId = null; value.chargeVerified = true;
          continue;
        }
        const charge = pricing.charges?.[category]?.[String(amount)];
        const market = this.catalog.currentMarketPrices?.[String(charge?.id)];
        if (value.dynamicPriceError || !charge?.verified || !/^\d+$/.test(String(charge?.id)) || !Number.isSafeInteger(market?.price) || market.price < 0) {
          value.dynamicPriceError ||= 'upgrade_price_unverified';
          value.price = 0; value.chargeVariantId = null; value.chargeVerified = false;
        } else {
          value.price = market.price; value.chargeVariantId = String(charge.id); value.chargeVerified = true;
        }
      }
    }
    finishState() {
      const suffix = this.variant.mode === 'Front + Rear' ? 'both' : 'single';
      const finish = this.selected['finish-' + suffix] || '';
      const anodized = finish.startsWith('anodized-') || finish.startsWith('hard-');
      const active = this.catalog.finishPolicy?.anodizedClearCoat === true;
      const coated = active && anodized && this.selected['clearcoat-' + suffix] === 'gloss-clear-coat';
      return {active, suffix, anodized, coated, rawOnly: active && anodized && !coated};
    }
    normalizeFinish() {
      const state = this.finishState();
      if (!state.active) return;
      for (const suffix of ['single', 'both']) {
        const finish = this.selected['finish-' + suffix] || '';
        if (!(finish.startsWith('anodized-') || finish.startsWith('hard-'))) this.selected['clearcoat-' + suffix] = 'without-clear-coat';
      }
      if (state.rawOnly) this.selected['logo-color'] = 'raw-alloy';
    }
    affectedAxles(option, value) {
      if (option.key.endsWith('-front')) return ['front'];
      if (option.key.endsWith('-rear')) return ['rear'];
      if (this.variant.mode !== 'Front + Rear') return [this.variant.mode === 'Front Kit' ? 'front' : 'rear'];
      if (value.key?.endsWith('front-only') || value.label?.includes('(Front only)')) return ['front'];
      if (value.key?.endsWith('rear-only') || value.label?.includes('(Rear only)')) return ['rear'];
      return ['front', 'rear'];
    }
    sizeRestriction(option, value) {
      const family = option.key.replace(/-(single|both|front|rear)$/, '');
      if (!['floating','wave'].includes(family) || !value || value.price <= 0 || value.dynamicPriceError) return null;
      if (this.disabledUpgrades.has(family === 'floating' ? 'Full-floating rotors' : 'Wave-cut rotors')) return null;
      const hardware = this.hardwareState?.hardware || this.catalog.factoryHardware?.[this.variant.id];
      if (!hardware) return null;
      const axles = this.affectedAxles(option,value);
      if (axles.some(axle => !hardware[axle] || hardware[axle].architecture === 'dual_feed_drift' || family === 'wave' && hardware[axle].architecture === 'integrated_parking_dust_boot')) return null;
      const restricted = axles.filter(axle => hardware[axle].diameter < 330 || hardware[axle].thickness < (axle === 'front' ? 32 : 28));
      return restricted.length ? restricted : null;
    }
    availabilityStatus(option, value) {
      const policy = this.catalog.availability;
      if (!policy?.enabled) return 'available_to_order';
      const family = option.key.replace(/-(single|both|front|rear)$/, '');
      const waveOption = this.options.get(this.variant.mode === 'Front + Rear' ? 'wave-both' : 'wave-single');
      const waveSelected = waveOption?.values.find(v => v.key === this.selected[waveOption.key])?.price > 0;
      if (!(['floating', 'wave'].includes(family) && value.price > 0) && !(family === 'surface' && waveSelected)) return 'available_to_order';
      const hardware = this.hardwareState?.hardware || this.catalog.factoryHardware?.[this.variant.id] || {};
      const states = this.affectedAxles(option, value).map(axle => {
        const reference = hardware[axle]?.reference;
        if (!reference) return family === 'floating' ? 'available_to_order' : 'confirmation_required';
        // Eligible full-floating hardware is orderable without a separate approval flag.
        const rows = (policy.records || []).filter(row => row.factory_reference === reference && row.option_key === family && row.option_value === value.key);
        const specific = rows.filter(row => row.vehicle_profile_id === policy.profileId);
        const candidates = specific.length ? specific : rows.filter(row => !row.vehicle_profile_id);
        if (candidates.length !== 1) return family === 'floating' ? 'available_to_order' : 'confirmation_required';
        if (family === 'floating' && candidates[0].status === 'confirmation_required') return 'available_to_order';
        return ['available_to_order', 'temporarily_unavailable', 'confirmation_required'].includes(candidates[0].status) ? candidates[0].status : 'confirmation_required';
      });
      return states.includes('temporarily_unavailable') ? 'temporarily_unavailable' : states.includes('confirmation_required') ? 'confirmation_required' : 'available_to_order';
    }
    visible(key, trail = new Set()) {
      const option = this.options.get(key);
      if (!option) return false;
      if (trail.has(key)) throw new Error('Circular option condition');
      const next = new Set(trail).add(key);
      if (option.group && !this.visible(option.group, next)) return false;
      // Rotor upgrades follow resolved hardware constraints, not historical label whitelists.
      if (/^boots-(single|both)$/.test(key)) return key.endsWith('-both') === (this.variant.mode === 'Front + Rear');
      if (/^(floating|wave)-(single|both)$/.test(key)) return key.endsWith('-both') === (this.variant.mode === 'Front + Rear');
      const rules = option.condition.rules;
      if (!rules.length) return true;
      const matches = rules.map(rule => {
        let actual;
        if (rule.field === 'configuration') actual = this.variant.configuration;
        else {
          if (!this.visible(rule.field, next)) return false;
          actual = this.selected[rule.field] || '';
        }
        if (rule.operator === 'EQUAL') return actual === rule.value;
        if (rule.operator === 'CONTAIN') return actual.includes(rule.value);
        if (rule.operator === 'NOT_CONTAIN') return !actual.includes(rule.value);
        throw new Error('Unsupported condition operator');
      });
      return option.condition.match === 'ANY' ? matches.some(Boolean) : matches.every(Boolean);
    }
    compatibleValue(option, value) {
      if (!value) return false;
      if (value.dynamicPriceError) return false;
      if (option.key === 'logo-color' && this.finishState().rawOnly) return value.key === 'raw-alloy';
      const family = option.key.replace(/-(single|both|front|rear)$/, '');
      const hardware = this.hardwareState?.hardware || this.catalog.factoryHardware?.[this.variant.id];
      const protectedAxles = this.hardwareState?.compulsoryBootAxles || [];
      if (this.catalog.hardwareCapabilities?.enabled && hardware) {
        const axles = this.affectedAxles(option, value);
        if (family === 'pistons') {
          const material = value.key.replace(/-pistons.*$/, '');
          if (axles.some(axle => !hardware[axle]?.allowedPistons?.includes(material))) return false;
        }
        if (family === 'springs' && value.key.startsWith('add') && axles.some(axle => hardware[axle]?.antiKnockbackSprings !== true)) return false;
        if (family === 'pads') {
          const compound = value.key.startsWith('pro-') ? 'pro' : value.key.split('-')[0];
          if (axles.some(axle => !hardware[axle]?.allowedPadCompounds?.includes(compound))) return false;
        }
      }

      if (family === 'boots' && hardware) {
        const axles = this.affectedAxles(option,value);
        const allRequired = axles.every(axle => protectedAxles.includes(axle));
        if (value.key.startsWith('internal') && allRequired) return false;
        if (!value.key.startsWith('internal') && axles.some(axle => !protectedAxles.includes(axle) && !this.hardwareState?.optionalBootAxles?.includes(axle))) return false;
      }
      if (['pistons','springs','wave'].includes(family) && value.price > 0 && hardware) {
        if (this.affectedAxles(option,value).some(axle => ['integrated_parking_dust_boot','dual_feed_drift'].includes(hardware[axle]?.architecture))) return false;
      }
      const disabledFamilies = {"boots": "Dust boots", "pads": "Brake pad upgrades", "pistons": "Piston upgrades", "springs": "Anti-knockback springs", "floating": "Full-floating rotors", "coating": "Protective rotor coating", "wave": "Wave-cut rotors", "finish": "Caliper finish upgrades"};
      if (value.price > 0 && this.disabledUpgrades.has(disabledFamilies[family])) return false;
      if (!['floating', 'wave'].includes(family) || value.price === 0) return true;
      if (hardware) {
        const approved = this.affectedAxles(option, value).every(axle => {
          const record = hardware[axle];
          if (!record || record.architecture === 'dual_feed_drift') return false;
          if (family === 'wave' && record.architecture === 'integrated_parking_dust_boot') return false;
          if (record.diameter < 330 || record.thickness < (axle === 'front' ? 32 : 28)) return false;
          return true;
        });
        if (!approved) return false;
        return true;
      }
      // Factory limits depend on both diameter and thickness, independently per axle.
      const sizes = [...this.variant.description.matchAll(/(\d{3})x(\d+)/g)].map(m => ({diameter:Number(m[1]),thickness:Number(m[2])}));
      const eligible = (size, axle) => !!size && size.diameter >= 330 && size.thickness >= (axle === 'front' ? 32 : 28);
      if (this.variant.mode !== 'Front + Rear') return eligible(sizes[0], this.variant.mode === 'Front Kit' ? 'front' : 'rear');
      if (value.label.includes('(Front only)')) return eligible(sizes[0], 'front');
      if (value.label.includes('(Rear only)')) return eligible(sizes[1], 'rear');
      return sizes.length === 2 && eligible(sizes[0], 'front') && eligible(sizes[1], 'rear');
    }
    valueAllowed(option, value) {
      return this.compatibleValue(option, value) && this.availabilityStatus(option, value) === 'available_to_order';
    }
    choose(key, valueKey) {
      const option = this.options.get(key);
      const value = option?.values.find(v => v.key === valueKey);
      if (!this.visible(key) || !value || !this.valueAllowed(option, value)) throw new Error('Unavailable option choice');
      if (key.startsWith('boots-')) this.dustRequired = !valueKey.startsWith('internal');
      this.selected[key] = valueKey;
      this.resolveHardware();
      this.applyUpgradePrices();
      this.normalizeFinish();
      for (const dependent of this.catalog.options) {
        if (!this.visible(dependent.key)) continue;
        const retained = dependent.values.find(candidate => candidate.key === this.selected[dependent.key]);
        if (retained && !this.valueAllowed(dependent, retained) && !(this.dustRequired && dependent.key.startsWith('boots-'))) this.selected[dependent.key] = dependent.key === 'surface' ? undefined : dependent.values.find(candidate => candidate.default && this.valueAllowed(dependent, candidate))?.key;
      }
    }
    migrateSelections(input) {
      const selected = {...input};
      for (const family of this.catalog.optionLayout?.splitAxles || []) {
        const legacy = selected[family + '-both'];
        if (legacy === undefined) continue;
        for (const axle of ['front','rear']) {
          const key = family + '-' + axle, option = this.options.get(key);
          if (!option || selected[key] !== undefined) continue;
          const otherAxle = axle === 'front' ? 'rear' : 'front';
          const candidate = legacy.endsWith('-' + otherAxle + '-only') ? option.values.find(value => value.default)?.key : legacy.replace(/-(front-rear|front-only|rear-only)$/, '');
          if (option.values.some(value => value.key === candidate)) selected[key] = candidate;
        }
        delete selected[family + '-both'];
      }
      return selected;
    }
    clearanceState(wheel) {
      const rows = Object.entries(this.hardwareState?.hardware || {}).map(([axle, hardware]) => ({axle,reference:hardware.reference,minimum:hardware.minimumWheelDiameterMm,nominal:hardware.nominalMinimumWheelInches,diameter:hardware.diameter,thickness:hardware.thickness}));
      const required = this.catalog.wheelClearancePolicy?.requireBelowNominalConfirmation === true && Number.isInteger(wheel) && rows.some(row => Number.isFinite(row.nominal) && wheel < row.nominal);
      const signature = JSON.stringify([wheel,rows.map(row=>[row.axle,row.reference,row.minimum,row.nominal,row.diameter,row.thickness])]);
      return {rows,required,signature,confirmed:!required || this.clearanceConfirmation === signature};
    }
    confirmClearance(wheel, confirmed) {
      this.clearanceConfirmation = confirmed ? this.clearanceState(wheel).signature : null;
    }
    selection() {
      const rows = [];
      for (const option of this.catalog.options) {
        if (option.type === 'group' || !this.visible(option.key)) continue;
        if (['text-box', 'text-area', 'file-upload'].includes(option.type)) {
          const text = this.text[option.key]?.trim();
          if (text && (!Array.isArray(option.allowedValues) || !option.allowedValues.length || option.allowedValues.map(String).includes(text))) rows.push({optionKey:option.key,label:option.label,value:text,price:0,type:option.type});
          continue;
        }
        const value = option.values.find(v => v.key === this.selected[option.key]);
        if (value && this.valueAllowed(option, value)) rows.push({optionKey:option.key,label:option.label,value:option.key.startsWith('boots-') && value.key.startsWith('internal') && value.price>0 ? 'Compulsory dust-boot calipers — ' + (this.hardwareState?.compulsoryBootAxles||[]).join(' and ') : value.label,price:value.price,chargeVariantId:value.chargeVariantId,verified:value.chargeVerified});
      }
      return rows;
    }
    requiredMissing() {
      const visible = this.catalog.options.filter(o => o.type !== 'group' && this.visible(o.key));
      const selected = this.selection();
      const missing = visible.filter(o => (o.required && !selected.some(s => s.optionKey === o.key)) || (this.selected[o.key] && o.values.some(v => v.key === this.selected[o.key] && (v.dynamicPriceError || (v.price > 0 && !this.valueAllowed(o,v)))))).map(o => o.label);
      return [...new Set([...missing,...(this.hardwareState?.blockers || []).map(blocker=>blocker.message)])];
    }
    configurationDescription() {
      if (!this.hardwareState) return this.variant.description;
      const describe = axle => { const h=this.hardwareState.hardware[axle];return h ? h.diameter+'x'+h.thickness+' mm — '+h.label : ''; };
      if (this.variant.mode === 'Front + Rear') return 'Front: '+describe('front')+' | Rear: '+describe('rear');
      return describe(this.variant.mode === 'Front Kit' ? 'front' : 'rear') || this.variant.description;
    }
    price() {
      const extras = this.selection().reduce((sum, v) => sum + v.price, 0);
      const parking = this.variant.mode !== 'Front Kit' && this.parkingIncluded ? this.catalog.parking.price : 0;
      return {kit:this.variant.price,parking,extras,total:this.variant.price+parking+extras,currency:this.catalog.currency};
    }
    cartPlan({quantity = 1, buildId = 'local-preview', wheel = ''} = {}) {
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Invalid kit quantity');
      if (this.hardwareState?.blockers?.length) throw new Error('hardware_mapping_unconfirmed');
      const selection = this.selection();
      if (selection.some(v => v.price > 0 && (!v.chargeVariantId || !v.verified))) throw new Error('Unverified upgrade charge');
      const properties = {'_ceika_build':buildId,'Kit configuration':this.configurationDescription()};
      if (this.hardwareState) for (const [axle,hardware] of Object.entries(this.hardwareState.hardware)) properties['_ceika_hardware_'+axle] = hardware.reference || '';
      if (wheel) properties['Wheel diameter'] = String(wheel);
      const clearance = this.clearanceState(parseInt(wheel,10));
      if (clearance.required && clearance.confirmed) { properties['_ceika_clearance'] = clearance.signature; properties['Wheel clearance'] = 'Checked with the exact template or CEIKA support'; }
      if (this.variant.mode !== 'Front Kit') properties['Rear parking brake'] = this.parkingIncluded ? this.catalog.parking.type : 'No e-brake';
      selection.forEach(s => { properties[s.label] = s.type === 'file-upload' ? this.uploads[s.optionKey] || s.value : s.value; });
      const charges = selection.filter(s => s.price > 0).map(s => ({id:s.chargeVariantId,quantity,properties:{'_ceika_build':buildId,'Upgrade':s.label,'Selection':s.value},unitPrice:s.price}));
      if (this.variant.mode !== 'Front Kit' && this.parkingIncluded) charges.unshift({id:this.catalog.parking.chargeVariantId,quantity,properties:{'_ceika_build':buildId,'Upgrade':'Rear parking brake','Selection':this.catalog.parking.type},unitPrice:this.catalog.parking.price});
      const blockedBy = [];
      const rear=catalogRearAvailability(this.catalog);
      if(this.variant.mode!=='Front Kit'&&(rear.rearChoiceDisabled||rear.parkingChoiceDisabled))blockedBy.push(rear.message||'Confirm rear fitment with CEIKA before ordering');
      if (clearance.required && !clearance.confirmed) blockedBy.push('Confirm wheel clearance for the selected calipers');
      if (this.requiredMissing().length) blockedBy.push('Choose: '+this.requiredMissing().join(', '));
      if (selection.some(s => s.type === 'file-upload' && !this.files[s.optionKey] && !this.uploads[s.optionKey])) blockedBy.push('Reference image must be selected again');
      return {mode:'test_cart',currency:this.catalog.currency,quantity,parent:{id:this.variant.id,quantity,properties,unitPrice:this.variant.price},children:charges,total:this.price().total*quantity,blockedBy};
    }
  }
  /** Display contract derived from explicit source facts; never invents why development is missing. */
  function rearAvailability(profile,{rearKitStatus='source',parkingDevelopmentStatus='unknown'}={}){
   const rear=profile.dimensions?.rear||[],parking=profile.parking?.type;
   const absent=rearKitStatus==='not_available'||parking==='front_only';
   if(absent)return {state:'rear_kit_unavailable',rearChoiceDisabled:true,frontRearChoiceDisabled:true,parkingChoiceDisabled:true,heading:'Rear kit not currently available',message:'A rear kit is not currently available for your vehicle. Contact us to discuss whether we can develop one.',contactAction:'Discuss rear-kit development',reason:'Source does not offer a rear kit; manufacturing reason not inferred.'};
   if(!rear.length)return {state:'rear_fitment_unconfirmed',rearChoiceDisabled:true,frontRearChoiceDisabled:true,parkingChoiceDisabled:true,heading:'Rear fitment needs confirmation',message:'Contact CEIKA to confirm rear-kit availability for your vehicle.',contactAction:'Confirm rear fitment',reason:'Missing or malformed source data is not proof that a kit was never developed.'};
   if(parkingDevelopmentStatus==='not_developed')return {state:'parking_not_developed',rearChoiceDisabled:false,frontRearChoiceDisabled:false,parkingChoiceDisabled:true,heading:'Parking-brake option not currently available',message:'Rear-kit sizes are listed, but a compatible parking-brake option is not currently available. Contact CEIKA before ordering this configuration.',contactAction:'Discuss parking-brake fitment',reason:'Explicit development status required.'};
   if(!['electronic','integrated_disc','drum_in_hat'].includes(parking))return {state:'parking_unconfirmed',rearChoiceDisabled:false,frontRearChoiceDisabled:false,parkingChoiceDisabled:true,heading:'Parking-brake fitment needs confirmation',message:'Rear-kit sizes are listed. Contact CEIKA to confirm the parking-brake configuration for your vehicle.',contactAction:'Confirm parking-brake options',reason:'The source parking field is unresolved; no development history inferred.'};
   return {state:'source_options_present',rearChoiceDisabled:false,frontRearChoiceDisabled:false,parkingChoiceDisabled:false,heading:'',message:'',contactAction:'',reason:'Explicit source facts; exact hardware/price approval remains separate.'};
  }
  
  function catalogRearAvailability(catalog){
   const p=catalog.rearAvailabilityProfile;
   if(!p)return {state:'legacy_unspecified',rearChoiceDisabled:false,frontRearChoiceDisabled:false,parkingChoiceDisabled:false,message:''};
   return rearAvailability({parking:{type:p.parkingType},dimensions:{rear:p.hasRearSizes?[{}]:[]},issues:[]},{rearKitStatus:p.rearKitStatus,parkingDevelopmentStatus:p.parkingDevelopmentStatus});
  }
  
  NativeOptions.dustCompatibleHardware = hardware => Boolean(hardware && !hardware.blockers?.length && Object.keys(hardware.hardware || {}).length && Object.values(hardware.hardware).every(row => row.dustSelected === true));
  NativeOptions.rearAvailability = catalogRearAvailability;
  NativeOptions.kitAllowed = (catalog, variantId) => {
    const canonical = id => catalog.variantAliases[String(id)] || String(id);
    const candidate = catalog.baseVariants.find(v => v.id === canonical(variantId));
    if (!candidate) return false;
    const rearGate = catalogRearAvailability(catalog);
    if(candidate.mode !== 'Front Kit' && rearGate.rearChoiceDisabled)return false;
    const excluded = new Set((catalog.policy?.disabledKits || []).map(canonical));
    if (excluded.has(candidate.id)) return false;
    if (candidate.mode !== 'Front + Rear') return true;
    const [front,rear] = candidate.description.replace(/^Front: /,'').split(' | Rear: ');
    return !catalog.baseVariants.some(v => excluded.has(v.id) &&
      ((v.mode === 'Front Kit' && v.description === front) || (v.mode === 'Rear Kit' && v.description === rear)));
  };
  global.CeikaNativeOptions = NativeOptions;
})(typeof window !== 'undefined' ? window : globalThis);

(() => {
const mountNativeOptions = (root, catalog) => {
  const display=window.CeikaOptionLocalization.display, tr=window.CeikaOptionLocalization.t;
  const labels = JSON.parse(root.querySelector('[data-native-labels]').textContent);
  const ui = JSON.parse(root.querySelector('[data-native-ui-labels]').textContent);
  const engine = new window.CeikaNativeOptions(catalog);
  const finishSamples=JSON.parse(root.querySelector('[data-native-finish-swatches]')?.textContent || '{}');
  const sampleKey=(option,value)=>{
    let key=value.key;
    if(['raw-polised-alloy','raw-alloy'].includes(key))key='raw-extra-milled-polished-calipers';
    if(option.key==='color-anodized' && engine.finishState().coated && finishSamples[key+'-clearcoat'])key+='-clearcoat';
    return key;
  };
  const sampleUrl=(option,value)=>finishSamples[sampleKey(option,value)] || value.image || '';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang||'en', {style:'currency',currency:engine.catalog.currency}).format(cents/100);
  const extras = root.querySelector('[data-pilot-extras]');
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  extras.replaceChildren(node('h2','',labels.extras_heading),node('p','native-intro',labels.extras_intro));
  const scope = () => engine.variant.mode === 'Front Kit' ? ui.front_scope : engine.variant.mode === 'Rear Kit' ? ui.rear_scope : ui.both_scope;
  const optionFamily = option => option.key.replace(/-(single|both|front|rear)$/, '');
  const optionTitle = option => {
    const family = optionFamily(option);
    if (ui[family + '_title']) return ui[family + '_title'];
    if(option.key==='custom-color')return tr(option.type==='file-upload'?'custom_image':'custom_color');
    if (option.key.startsWith('color-')) return ui.color_title;
    if (option.key === 'hat-color') return ui.hat_title;
    if (option.key === 'logo-color') return ui.logo_title;
    return display(option.label);
  };
  const choiceTitle = (option, value) => {
    const family = optionFamily(option), key = value.key;
    if (option.key === 'logo-color' && key === 'raw-alloy') return ui.logo_raw;
    if (family === 'clearcoat') return key === 'gloss-clear-coat' ? ui.clearcoat_add : ui.clearcoat_none;
    if (family === 'boots' && key.startsWith('internal') && value.price > 0) return ui.boots_required_only;
    const title = {
      boots: key.startsWith('internal') ? ui.boots_standard : ui.boots_upgrade,
      pistons: key.startsWith('standard') ? ui.piston_standard : key.startsWith('vented-stainless') ? ui.piston_vented_stainless : key.startsWith('vented') ? ui.piston_vented : ui.piston_stainless,
      springs: key.startsWith('add') ? ui.springs_upgrade : ui.springs_standard,
      wave: key === 'add' ? ui.wave_upgrade : ui.wave_standard,
      floating: key.startsWith('standard') ? ui.floating_standard : ui.floating_upgrade,
      coating: key === 'no-coating' ? ui.coating_standard : key.startsWith('black') ? ui.coating_black : ui.coating_silver,
      finish: key.startsWith('anodized') ? ui.finish_anodized : key.startsWith('gloss') ? ui.finish_gloss : key.startsWith('custom') ? ui.finish_custom : key.startsWith('hard') ? ui.finish_hard : ui.finish_raw,
      pads: key.startsWith('pro-') ? ui.pad_pro : key.startsWith('sport') ? ui.pad_sport : key.startsWith('race') ? ui.pad_race : ui.pad_street
    }[family];
    if (title) return title;
    return display(value.label);
  };
  const optionScope = option => option.key.endsWith('-front') ? ui.front_scope : option.key.endsWith('-rear') ? ui.rear_scope : scope();
  const choiceScope = (option, value) => {
    if (option.key.endsWith('-front')) return ui.front_only;
    if (option.key.endsWith('-rear')) return ui.rear_only;
    if (!option.key.endsWith('-both') || value.price === 0) return '';
    return value.key.endsWith('front-only') ? ui.front_only : value.key.endsWith('rear-only') ? ui.rear_only : ui.both_axles;
  };
  const scopeLine = node('div','native-scope-line');
  scopeLine.append(node('strong','native-scope-title'),node('span','native-scope-help'));
  extras.append(scopeLine);
  const hardwareNotice = node('p','native-hardware-notice');
  hardwareNotice.setAttribute('role','status'); hardwareNotice.hidden = true;
  extras.append(hardwareNotice);
  const clearanceBox = root.querySelector('[data-native-clearance]');
  const clearanceCheck = root.querySelector('[data-native-clearance-confirm]');
  clearanceCheck?.addEventListener('change', () => {engine.confirmClearance(Number(root.dataset.wheel),clearanceCheck.checked);update();});
  const groupLanguage = document.documentElement.lang.toLowerCase().split('-')[0];
  const groupCopy = ({
    fr: {price:'Options de cette section : +[price]', includes:'Dans cette section : ',
      'group-1':'Consultez les protections antipoussière disponibles ou requises pour votre configuration.',
      'group-2':'Comparez les plaquettes et les options disponibles pour les étriers selon votre utilisation.',
      'group-3':'Personnalisez les disques avec les surfaces et les options de construction proposées pour votre kit.',
      'group-4':'Choisissez les finitions et les couleurs pour personnaliser votre kit.',
      'group-5':'Précisez votre véhicule et ajoutez les informations utiles à la préparation de votre commande.'},
    es: {price:'Extras de esta sección: +[price]', includes:'En esta sección: ',
      'group-1':'Revise las protecciones antipolvo disponibles o necesarias para su configuración.',
      'group-2':'Compare las pastillas y las opciones de pinza disponibles según su uso.',
      'group-3':'Personalice los discos con las superficies y opciones de construcción disponibles para su kit.',
      'group-4':'Elija los acabados y colores para personalizar su kit.',
      'group-5':'Indique su vehículo y añada los detalles necesarios para preparar su pedido.'}
  })[groupLanguage] || {price:'Upgrades in this section: +[price]', includes:'In this section: ',
    'group-1':'Review the dust protection available or required for your selected configuration.',
    'group-2':'Compare brake pads and available caliper upgrades for the way you drive.',
    'group-3':'Explore the rotor surfaces and construction upgrades available for your selected kit.',
    'group-4':'Choose finishes and colours to personalise the look of your kit.',
    'group-5':'Add your vehicle specification and any details we should check when preparing your order.'};
  const groups = new Map();
  for (const group of engine.catalog.options.filter(o => o.type === 'group')) {
    const details = node('details','native-options-group');
    details.dataset.group = group.key;
    const summary = node('summary');
    const heading = node('span','native-group-heading');
    heading.append(node('strong','',tr(group.key.replace('-','_'))),node('span','native-group-price'));
    summary.append(heading,node('span','ceika-group-explanation',groupCopy[group.key] || ''),node('span','ceika-section-description'),node('span','native-group-summary'),node('span','ceika-section-missing'));
    details.append(summary,node('div','native-group-body'));
    summary.addEventListener('click',event => {
      event.preventDefault();
      const before = summary.getBoundingClientRect().top;
      const opening = !details.open;
      if (opening) mountGroup(group.key);
      details.open = opening;
      const delta = summary.getBoundingClientRect().top - before;
      if (Math.abs(delta) > 1) window.scrollBy({top:delta,behavior:'instant'});
    });
    details.addEventListener('toggle',() => { if(details.open) mountGroup(group.key); });
    groups.set(group.key,details);extras.append(details);
  }
  const controls = new Map();
  const french = document.documentElement.lang.toLowerCase().startsWith('fr');
  const sizeMessage = axles => tr('size_below').replace('[sizes]',axles.map(axle=>'330 × '+(axle==='front'?'32':'28')+' mm ('+tr(axle)+')').join(' / '));

  const renderOption = option => {
    if (controls.has(option.key)) return;
    const field = node('fieldset','native-option');field.dataset.option = option.key;
    const legend = node('legend');
    legend.append(node('span','native-option-title',optionTitle(option) + (option.required ? ' *' : '')));
    if (/-(single|both|front|rear)$/.test(option.key)) legend.append(node('span','native-option-scope',optionScope(option)));
    else if (!option.required && ['text-box','text-area'].includes(option.type)) legend.append(node('span','native-option-scope',ui.optional));
    field.append(legend);
    if (optionFamily(option) === 'clearcoat') {
      field.classList.add('native-clearcoat');
      const explanation = node('div','native-clearcoat-explanation');
      explanation.append(node('strong','',ui.clearcoat_heading),node('p','',ui.clearcoat_help));
      field.append(explanation);
    }
    if (option.key === 'logo-color') field.append(node('p','native-help native-logo-note'));
    if (optionFamily(option) === 'boots') field.append(node('p','native-help native-boots-note'));
    if(option.type === 'image-swatches') field.append(node('p','native-selected-choice'));
    if(option.key==='color-anodized' || option.key==='color-gloss'){
      const preview=node('div','native-finish-preview');preview.hidden=true;
      const image=node('img');image.width=96;image.height=96;image.alt='';image.loading='lazy';image.decoding='async';
      const caption=node('p');preview.append(image,caption);field.append(preview);
    }
    const help = optionFamily(option) === 'finish' ? ui.finish_help : optionFamily(option) === 'floating' ? ui.floating_help : option.key === 'custom-color' ? ui.custom_help : '';
    if (help) field.append(node('p','native-help',help));
    if (['text-box','text-area','file-upload'].includes(option.type)) {
      const allowedTextValues = option.type === 'text-box' && Array.isArray(option.allowedValues) ? [...new Set(option.allowedValues.map(String))] : [];
      const input = node(allowedTextValues.length ? 'select' : option.type==='text-area'?'textarea':'input');
      if (allowedTextValues.length) {
        const placeholder = node('option', '', optionTitle(option));placeholder.value='';input.append(placeholder);
        allowedTextValues.forEach(value => {const choice=node('option','',value);choice.value=value;input.append(choice);});
        input.required=Boolean(option.required);input.style.width='100%';input.style.maxWidth='100%';
        if (!allowedTextValues.includes(String(engine.text[option.key] || '').trim())) delete engine.text[option.key];
        input.addEventListener('change',()=>{engine.text[option.key]=input.value;update();});
      }
      if(input.tagName==='INPUT')input.type=option.type==='file-upload'?'file':'text';
      if(option.type==='file-upload')input.accept='image/png,image/jpeg,image/webp';else input.maxLength=option.key==='comments'?255:200;
      if (input.type !== 'file') input.value = engine.text[option.key] || '';
      input.setAttribute('aria-label',optionTitle(option));
      input.addEventListener('input',() => {
        if(input.type==='file'){
          delete engine.uploads[option.key];
          const file=input.files?.[0];
          engine.files[option.key]=file;
          engine.text[option.key]=file?.name||'';
        }else engine.text[option.key]=input.value;
        update();
      });
      field.append(input);
      if(option.key==='custom-color' && option.type==='text-box'){
        input.placeholder=tr('color_example');
        const pickerLabel=node('label','native-color-reference-picker',tr('picker'));
        const picker=node('input');picker.type='color';picker.setAttribute('aria-label',tr('picker_label'));
        picker.style.width='72px';picker.style.height='40px';picker.style.margin='8px 12px';
        const existing=String(engine.text[option.key]||'').match(/^(?:HEX\s*)?(#[0-9a-f]{6})$/i);
        if(existing)picker.value=existing[1];
        picker.addEventListener('input',()=>{input.value=picker.value.toUpperCase();engine.text[option.key]=input.value;update();});
        pickerLabel.append(picker);field.append(pickerLabel);
      }
      if(option.type==='file-upload'){

        field.append(node('p','native-help',labels.file_note));
        const saved=node('a','native-saved-upload',labels.saved_upload);saved.dataset.savedUpload='';saved.target='_blank';saved.rel='noopener';saved.hidden=true;
        const remove=node('button','native-upload-remove',labels.remove_upload);remove.type='button';remove.dataset.removeUpload='';
        remove.addEventListener('click',()=>{delete engine.files[option.key];delete engine.uploads[option.key];delete engine.text[option.key];input.value='';update();});
        field.append(saved,remove);
      }
    } else {
      const values = node('div',option.type==='image-swatches'?'native-swatches'+(option.key==='surface'?' native-surface-swatches':' native-color-swatches'):'native-buttons');
      for (const value of option.values) {
        const label=node('label','native-choice');
        const input=node('input');input.type='radio';input.name='native-'+option.key;input.value=value.key;
        input.addEventListener('change',()=>{if(optionFamily(option)==='boots'){root.setDustRequirement(!value.key.startsWith('internal'),{notify:true,manual:true});return;}engine.choose(option.key,value.key);update();});
        const body=node('span','native-choice-body');
        if(sampleUrl(option,value)){const img=node('img');img.src=sampleUrl(option,value);img.alt='';img.width=44;img.height=44;img.loading='lazy';img.decoding='async';body.append(img);}
        body.append(node('span','native-choice-title',choiceTitle(option,value)));
        const axle = choiceScope(option,value);
        if (axle) body.append(node('span','native-choice-scope',axle));
        if (option.type !== 'image-swatches' || value.price) body.append(node('small','native-choice-price',value.price ? '+'+money(value.price) : (option.key.startsWith('springs-') ? ui.springs_not_included : ui.included)));
        const availability = node('small','native-choice-availability');availability.hidden = true;body.append(availability);
        input.setAttribute('aria-label', [choiceTitle(option,value),axle,value.price ? '+'+money(value.price) : (option.key.startsWith('springs-') ? ui.springs_not_included : ui.included)].filter(Boolean).join(' · '));
        label.append(input,body);values.append(label);
      }
      field.append(values);
      const availabilityHelp = node('div','native-availability-help'); availabilityHelp.hidden = true;
      const supportLink = root.closest('.ceika-product-pilot')?.querySelector('a[href^="#ceika-fitment-"]');
      if (supportLink) { const link = node('a','',ui.availability_contact);link.href=supportLink.getAttribute('href');availabilityHelp.append(link); }
      field.append(availabilityHelp);
      if (['floating','wave'].includes(optionFamily(option))) {
        const sizeHelp=node('div','native-size-upsell');sizeHelp.hidden=true;
        const text=node('p');const explore=node('button','native-size-explore',tr('size_explore'));explore.type='button';
        explore.addEventListener('click',()=>{const target=root.querySelector('[data-pilot-axle]') || root.querySelector('[data-pilot-variant]');if(target){target.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}});
        sizeHelp.append(text,explore);field.append(sizeHelp);
      }
    }
    const group=groups.get(option.group);
    if(group)group.querySelector('.native-group-body').append(field);else extras.append(field);
    controls.set(option.key,field);
  };
  const mounted = new Set();
  const mountGroup = key => {
    if (mounted.has(key)) return;
    engine.catalog.options.filter(o => o.type !== 'group' && o.group === key).forEach(renderOption);
    mounted.add(key); update();
  };
  engine.catalog.options.filter(o => o.type !== 'group' && !groups.has(o.group)).forEach(renderOption);
  const update=()=>{
    const selected=root.querySelector('[data-pilot-variant]').value;
    if(!selected && !root._dustRequired)return;
    engine.dustSelectionPending=Boolean(root._dustPending);
    engine.parkingIncluded=root.querySelector('[data-pilot-parking-choice]:checked')?.value!=='No e-brake';
    if(selected)engine.setVariant(selected);else {engine.resolveHardware();engine.applyUpgradePrices();}
    root.querySelectorAll('[data-pilot-card]').forEach(card=>{
      const input=card.querySelector('[data-pilot-configuration]');
      const price=card.querySelector('.ceika-choice__price');
      if(!input || !price || input.hasAttribute('data-pilot-price-pending'))return;
      const axle=card.closest('[data-pilot-axle]').dataset.pilotAxle;
      const base=engine.catalog.baseVariants.find(v=>v.mode===axle&&v.description===input.value);
      if(base)price.textContent=money(base.price)+' '+engine.catalog.currency;
    });
    controls.forEach((field,key)=>{
      const option=engine.options.get(key),visible=engine.visible(key);
      if(option.type==='file-upload'){
        const saved=field.querySelector('[data-saved-upload]'),remove=field.querySelector('[data-remove-upload]');
        saved.hidden=!window.CeikaNativeCart.savedUpload(engine.uploads[key]);
        if(!saved.hidden)saved.href=engine.uploads[key];else saved.removeAttribute('href');
        remove.hidden=!engine.text[key];
      }
      const choices=option.values.filter(value=>engine.valueAllowed(option,value));
      const paidDisabled=option.values.some(value=>value.price>0 || value.dynamicPriceError) && choices.length===1 && choices[0].price===0;
      const availabilityPending=option.values.some(value=>engine.compatibleValue(option,value) && engine.availabilityStatus(option,value)!=='available_to_order');
      const sizeBlocked=option.values.some(value=>engine.sizeRestriction(option,value));
      const dustControl=optionFamily(option)==='boots';
      field.hidden=!visible || (!dustControl && paidDisabled && !availabilityPending && !sizeBlocked);
      const sizeHelp=field.querySelector('.native-size-upsell');if(sizeHelp){sizeHelp.hidden=!sizeBlocked;sizeHelp.querySelector('p').textContent=tr('size_help');}

      const availabilityHelp=field.querySelector('.native-availability-help');if(availabilityHelp)availabilityHelp.hidden=!availabilityPending;
      const logoNote=field.querySelector('.native-logo-note');if(logoNote){logoNote.textContent=engine.finishState().rawOnly?ui.logo_raw_help:engine.finishState().coated?ui.logo_coated_help:'';logoNote.hidden=!logoNote.textContent;}
      const bootsNote=field.querySelector('.native-boots-note');if(bootsNote){bootsNote.hidden=!root._dustIntent.environment && (!selected || !engine.hardwareState?.compulsoryBootAxles?.length);bootsNote.textContent=root._dustIntent.environment?root._dustLabels.environment:ui.boots_compulsory;}
      field.querySelectorAll('input,textarea,select').forEach(input=>{
        if (input.tagName==='SELECT') input.value=engine.text[key] || '';
        const value=option.values.find(v=>v.key===input.value);
        const mandatoryDust=Boolean(selected) && dustControl && value?.key.startsWith('internal') && engine.affectedAxles(option,value).every(axle=>engine.hardwareState?.compulsoryBootAxles?.includes(axle));
        input.disabled=!visible || (input.type==='radio'&&(dustControl?(mandatoryDust || (value?.key.startsWith('internal') && root._dustIntent.environment)):!engine.valueAllowed(option,value)));
        if(input.type==='radio'){
          input.checked=engine.selected[key]===input.value;
          const sample=input.closest('label').querySelector('img');if(sample){const url=sampleUrl(option,value);if(sample.getAttribute('src')!==url)sample.src=url;}
          const sizeAxles=engine.sizeRestriction(option,value);
          const label=input.closest('label');label.hidden=!dustControl && !engine.compatibleValue(option,value) && !sizeAxles;
          const availability=engine.availabilityStatus(option,value),badge=label.querySelector('.native-choice-availability');
          badge.hidden=!sizeAxles && availability==='available_to_order';badge.textContent=sizeAxles?sizeMessage(sizeAxles):availability==='temporarily_unavailable'?ui.availability_unavailable:ui.availability_confirm;
          label.style.opacity=sizeAxles?'0.55':'';label.style.cursor=sizeAxles?'not-allowed':'';
          label.classList.toggle('native-choice--unavailable',!badge.hidden);
          label.querySelector('.native-choice-title').textContent=choiceTitle(option,value);
          const price=label.querySelector('.native-choice-price');if(price)price.textContent=dustControl&&!value.key.startsWith('internal')&&!engine.valueAllowed(option,value)?root._dustLabels.option_select:value.price?'+'+money(value.price):(option.key.startsWith('springs-') ? ui.springs_not_included : ui.included);
          input.setAttribute('aria-label',[choiceTitle(option,value),choiceScope(option,value),value.price?'+'+money(value.price):(option.key.startsWith('springs-') ? ui.springs_not_included : ui.included),badge.hidden?'':badge.textContent].filter(Boolean).join(' · '));
        }
      });
    });
    scopeLine.querySelector('.native-scope-title').textContent = engine.variant.mode === 'Front Kit' ? ui.front_context : engine.variant.mode === 'Rear Kit' ? ui.rear_context : ui.both_context;
    scopeLine.querySelector('.native-scope-help').textContent = engine.variant.mode === 'Front + Rear' ? ui.both_help : ui.single_help;
    controls.forEach((field,key) => {
      const option = engine.options.get(key);
      const badge = field.querySelector('.native-option-scope');
      if (badge && /-(single|both|front|rear)$/.test(key)) badge.textContent = optionScope(option);
      const preview=field.querySelector('.native-finish-preview');
      if(preview){const value=option.values.find(v=>v.key===engine.selected[key]);preview.hidden=!value || field.hidden;if(value){preview.querySelector('img').src=sampleUrl(option,value);preview.querySelector('p').textContent=choiceTitle(option,value)+(key==='color-anodized'&&engine.finishState().coated?' · '+tr('gloss_clear'):'')+' — '+tr('texture_preview');}}
      const selected = field.querySelector('.native-selected-choice');
      if (selected) {
        const value = option.values.find(v => v.key === engine.selected[key]);
        selected.textContent = value ? ui.selected.replace('[value]',choiceTitle(option,value)) : ui.choose;
      }
    });
    const selections=engine.selection();
    groups.forEach((details,key)=>{
      const option=engine.options.get(key);details.hidden=!engine.visible(key);
      const groupSelections=selections.filter(s=>option.children.includes(s.optionKey));
      const pending = catalog.options.filter(o => option.children.includes(o.key) && o.required && engine.visible(o.key) && !groupSelections.some(s => s.optionKey === o.key));
      const groupPrice = groupSelections.reduce((sum,s) => sum + s.price,0);
      const priceLabel = details.querySelector('.native-group-price');
      priceLabel.textContent = groupPrice ? groupCopy.price.replace('[price]',money(groupPrice)) : '';
      priceLabel.hidden = !groupPrice;
      const summaryValues = groupSelections.filter(s => key === 'group-5' ? s.optionKey === 'vehicle' : key === 'group-3' ? s.price > 0 || s.optionKey === 'surface' : key === 'group-4' ? s.optionKey.startsWith('finish-') || s.optionKey.startsWith('color-') || s.optionKey.startsWith('clearcoat-') && s.price>0 : s.optionKey.startsWith('springs-') ? s.price > 0 : true);
      const shortValues = summaryValues.map(s => {
        const o = engine.options.get(s.optionKey), v = o.values.find(v => v.key === engine.selected[s.optionKey]);
        return v ? [choiceTitle(o,v),choiceScope(o,v)].filter(Boolean).join(' — ') : s.value;
      });
      const descriptions = catalog.options.filter(o=>option.children.includes(o.key)&&engine.visible(o.key)).map(optionTitle);
      details.querySelector('.ceika-section-description').textContent=descriptions.length ? groupCopy.includes+[...new Set(descriptions)].join(' · ') : '';
      const indicator=details.querySelector('.ceika-section-missing');
      indicator.hidden=!pending.length;
      indicator.textContent=pending.length?'! '+ui.needed.replace('[count]',String(pending.length)):'';
      details.dataset.missing=String(pending.length>0);
      details.querySelector('.native-group-summary').textContent = shortValues.join(' · ') || labels.open_group;
    });
    if (clearanceBox) {
      const clearance = engine.clearanceState(Number(root.dataset.wheel));
      const known = clearance.rows.filter(row=>Number.isFinite(row.minimum));
      clearanceBox.hidden = !selected || !catalog.wheelClearancePolicy?.enabled || known.length === 0;
      if (!clearanceBox.hidden) root.querySelector('[data-larger-fitment]').hidden = true;
      clearanceBox.querySelector('[data-native-clearance-rows]').replaceChildren(...known.map(row => node('p','native-clearance-row',(Number.isFinite(row.nominal) ? ui.clearance_row : ui.clearance_row_without_nominal).replace('[axle]',row.axle==='front'?ui.front_scope:ui.rear_scope).replace('[diameter]',row.minimum).replace('[wheel]',row.nominal))));
      clearanceBox.querySelector('[data-native-clearance-check]').hidden = !clearance.required;
      clearanceCheck.checked = clearance.required && clearance.confirmed;
    }
    const price=engine.price();
    root.querySelectorAll('[data-pilot-grand-total],[data-review-grand-total]').forEach(el=>el.textContent=money(price.total)+' '+engine.catalog.currency);
    root.querySelector('[data-pilot-price]').textContent=money(price.kit)+' '+engine.catalog.currency;
    root.querySelector('[data-pilot-selection]').textContent=selected?display(engine.configurationDescription().replace(' | Rear: ','\nRear: ')):root._dustLabels.option_select;
    root.querySelector('[data-pilot-price]').nextElementSibling.textContent=labels.kit_note;
    root.querySelector('[data-parking-price="Electronic E-brake"]').textContent='+'+money(engine.catalog.parking.price);
    root.querySelector('[data-parking-price="No e-brake"]').textContent=labels.no_charge;
    root.dispatchEvent(new CustomEvent('ceika:total',{detail:price}));
    root.dataset.extrasPriceState=selected?'ready':'pending';
    if(!selected)root.querySelectorAll('[data-pilot-grand-total],[data-review-grand-total]').forEach(el=>{el.textContent=root._dustLabels.option_select;});
    delete root.dataset.nativeError;
    const blocked=Boolean(engine.hardwareState?.blockers?.length);
    root.dataset.hardwareBlocked=String(blocked);
    hardwareNotice.hidden=!blocked || Boolean(root._dustPending);hardwareNotice.textContent=blocked?ui.hardware_unconfirmed:'';
    root.querySelectorAll('[data-native-add]').forEach(button=>{button.disabled=blocked || engine.catalog.checkoutEnabled !== true;});
    root.nativeCartController?.changed();
  };
  root.extrasController={engine, update, displayOption:optionTitle, displayChoice:choiceTitle, setVehicle:value=>{
    if (engine.text.vehicle && engine.text.vehicle !== root._garageVehicle) return;
    engine.text.vehicle = value; root._garageVehicle = value;
    const input = controls.get('vehicle')?.querySelector('input'); if (input) input.value = value;
    update();
  }, restore:saved=>{
    engine.selected = {...engine.selected,...engine.migrateSelections(saved.selected)};
    engine.setDustRequired(Boolean(root._dustRequired)); engine.clearanceConfirmation = saved.clearance || null; engine.text = {...saved.text}; engine.uploads={...saved.uploads};engine.files={};
    controls.forEach((field,key)=>{const input=field.querySelector('input[type="text"],textarea,select');if(input)input.value=engine.text[key]||'';});
    update();
  }, revealMissing:()=>{
    const missing = new Set(engine.requiredMissing());
    const option = catalog.options.find(o => missing.has(o.label));
    if (!option) return;
    const group = groups.get(option.group);
    if (group) {mountGroup(option.group);group.open=true;}
    requestAnimationFrame(()=>{
      const field=controls.get(option.key);
      field?.scrollIntoView({block:'center',behavior:'auto'});
      field?.querySelector('input:not(:disabled),textarea:not(:disabled),select:not(:disabled)')?.focus({preventScroll:true});
    });
  }};
  root.addEventListener('change',event=>{if(event.target.matches('[data-pilot-variant]'))update();},{signal:root._nativeAbort.signal});
  update();
  root.nativeCartController=window.CeikaNativeCart.attach(root,engine,labels);
};


if (!customElements.get('ceika-native-configurator')) {
  customElements.define('ceika-native-configurator', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }
    async initialize() {
      if (!this.isConnected || this._nativeAbort && !this._nativeAbort.signal.aborted) return;
      this._nativeAbort = new AbortController();
      this.dataset.initialized = 'true';
      const variants = this.querySelector('[data-pilot-variant]');
      const display=window.CeikaOptionLocalization.display;
      this.querySelectorAll('.ceika-native-pilot__axle-title, [data-pilot-card] .ceika-choice__body strong').forEach(label=>{label.textContent=display(label.textContent);});
      this.querySelectorAll('[data-pilot-position]').forEach(input=>{const label=input.closest('label')?.querySelector('.ceika-choice__body');if(label)label.textContent=display(input.value);});
      const catalog = JSON.parse(this.querySelector('[data-native-catalog]').textContent);
      const hardware=JSON.parse(this.querySelector('[data-native-hardware]').textContent);
      if(!hardware?.factoryHardware||!hardware?.hardwareCapabilities)throw Error('Hardware connection missing');
      Object.assign(catalog,hardware);
      variants.replaceChildren();
      for (const item of catalog.baseVariants) {
        const combined = item.mode === 'Front + Rear';
        const [front, rear] = combined ? item.description.replace(/^Front: /, '').split(' | Rear: ') : [item.mode==='Front Kit'?item.description:'',item.mode==='Rear Kit'?item.description:''];
        for (const parking of item.mode==='Front Kit'?['Not applicable']:['Electronic E-brake','No e-brake']) {
          const option = document.createElement('option');option.value=item.id;option.textContent=display(item.configuration);
          Object.assign(option.dataset,{position:item.mode,parking,front,rear,configuration:item.description,price:'',dust:String(front.includes('XXL 6-piston'))});variants.append(option);
        }
      }
      const choices = Array.from(variants.options);

      const productPolicy = JSON.parse(this.querySelector('[data-native-policy]')?.textContent || '{}');
      catalog.policy = {...catalog.policy,...productPolicy,disabledKits:[...new Set([...(catalog.policy?.disabledKits||[]),...(productPolicy.disabledKits||[])])],disabledUpgrades:[...new Set([...(catalog.policy?.disabledUpgrades||[]),...(productPolicy.disabledUpgrades||[])])]};
      const signal = this._nativeAbort.signal;
      const words = JSON.parse(this.querySelector('[data-native-cart-labels]').textContent);
      const config = JSON.parse(this.querySelector('[data-native-cart-config]').textContent);
      const extras = this.querySelector('[data-pilot-extras]');
      extras.setAttribute('role', 'status');
      extras.textContent = words.prices_loading;
      this.dataset.priceLoadState = 'loading';
      this.querySelectorAll('[data-pilot-review], [data-native-add]').forEach(button => { button.disabled = true; });
      let feed;
      try { feed = JSON.parse(this.querySelector('[data-native-storefront-prices]').textContent); } catch (_) { feed = {}; }
      try {
        await window.CeikaNativeCart.loadPrices(catalog, feed, JSON.parse(this.querySelector('[data-native-price-products]').textContent), {root:config.root, signal});
        if (config.connection?.release?.mode === 'draft_preview') this.dataset.catalogueDraftPreview = 'true';
        if (signal.aborted || !this.isConnected) return;
        this.dataset.priceLoadState = 'ready';
        delete this.dataset.nativeError;
      } catch (error) {
        if (signal.aborted || !this.isConnected) return;
        this.dataset.nativeError = 'true';
        this.dataset.priceLoadState = 'error';
        this.dataset.priceLoadError = error.code || error.message;
        extras.replaceChildren();
        const message = document.createElement('p');
        message.textContent = catalog.draftDesignReview?.enabled ? words.draft_unavailable : words.prices_failed;
        const retry = document.createElement('button');
        retry.type = 'button'; retry.className = 'ceika-button'; retry.dataset.retryPrices = '';
        retry.textContent = words.prices_retry;
        retry.addEventListener('click', () => { this._nativeAbort.abort(); this.initialize(); }, {once:true, signal});
        extras.append(message, retry);
        return;
      }
      const usd = new Intl.NumberFormat(document.documentElement.lang||'en', {style:'currency', currency:catalog.currency});
      const basePrices = new Map(catalog.baseVariants.map(variant => [variant.id, variant.price]));
      choices.forEach(option => {
        const cents = basePrices.get(catalog.variantAliases[option.value] || option.value);
        option.dataset.price = Number.isFinite(cents) ? usd.format(cents / 100) + ' ' + catalog.currency : this.dataset.pricePending;
      });
      let previousPricedVariant = null;
      const fitment = JSON.parse(this.querySelector('[data-pilot-fitment]').textContent);
      this.querySelectorAll('.ceika-native-pilot__axle-title').forEach(title=>{title.textContent=display(title.textContent);});
      const positions = [...this.querySelectorAll('[data-pilot-position]')];
      const rearStatus=window.CeikaNativeOptions.rearAvailability(catalog);
      const rearNotice=this.querySelector('[data-rear-availability]');
      if(rearNotice){rearNotice.hidden=!rearStatus.message;rearNotice.querySelector('strong').textContent=display(rearStatus.heading||'');rearNotice.querySelector('p').textContent=display(rearStatus.message||'');rearNotice.querySelector('a').textContent=display(rearStatus.contactAction||'');}
      positions.forEach(input=>{const label=input.closest('label')?.querySelector('.ceika-choice__body');if(label)label.textContent=display(input.value);if(input.value!=='Front Kit'&&rearStatus.rearChoiceDisabled){input.disabled=true;input.closest('label').setAttribute('aria-disabled','true');}});
      const panels = [...this.querySelectorAll('[data-pilot-axle]')];
      const range = this.querySelector('[data-wheel-range]');
      const ticks = [...this.querySelectorAll('[data-wheel-size]')];
      const state = {};
      const dustPending=new Set(),rotorState={};
      this._dustRequired=false;this._dustPending=false;this._dustIntent={manual:false,environment:false};
      this._dustLabels=JSON.parse(this.querySelector('[data-dust-filter-labels]').textContent);
      const params = new URL(location.href).searchParams;
      const initial = choices.find(option => option.value === params.get('variant')) || variants.selectedOptions[0];
      let mode = initial.dataset.position;
      const requestedWheel = Number(params.get('wheel'));
      const initialWheels = fitment[initial.value] || [];
      let wheel = Number.isInteger(requestedWheel) && requestedWheel >= 15 && requestedWheel <= 22
        ? requestedWheel : initialWheels.includes(18) ? 18 : initialWheels[0] || 18;
      let parking = initial.dataset.parking === 'No e-brake' ? 'No e-brake' : 'Electronic E-brake';
      const parkingChoices = [...this.querySelectorAll('[data-pilot-parking-choice]')];
      const parkingLabel=this.querySelector('[data-parking-price="Electronic E-brake"]')?.closest('label')?.querySelector('strong');
      if(parkingLabel)parkingLabel.textContent=display(catalog.parking.type);
      const physicalCache=new Map();
      const physicalHardware = option => {
        if(!catalog.factoryPolicy?.enabled)return null;
        const key=option.value+':'+parking+':'+this._dustRequired;
        if(!physicalCache.has(key))physicalCache.set(key,window.CeikaFactoryPolicy.resolve({catalog,variant:catalog.baseVariants.find(v=>v.id===(catalog.variantAliases[option.value]||option.value)),parkingIncluded:parking!=='No e-brake',selected:this._dustRequired?{'boots-front':true,'boots-rear':true}:{}}));
        return physicalCache.get(key);
      };
      let eligibilityKey='',eligibilityCache=[];
      const eligibleChoices = () => {
        const key=[mode,parking,wheel,this._dustRequired].join(':');
        if(key!==eligibilityKey){eligibilityKey=key;eligibilityCache=choices.filter(option => window.CeikaNativeOptions.kitAllowed(catalog, option.value) && option.dataset.position === mode && (mode === 'Front Kit' || option.dataset.parking === parking) && (fitment[option.value] || []).includes(wheel) && !physicalHardware(option)?.blockers?.length && (!this._dustRequired || window.CeikaNativeOptions.dustCompatibleHardware(physicalHardware(option))) && window.CeikaHardwareCapabilities.wheelAllowed(catalog,physicalHardware(option),wheel));}
        return eligibilityCache;
      };
      const allowedConfigurations = axle => new Set(eligibleChoices()
        .filter(option => mode !== 'Front + Rear' || axle === 'Front Kit' || !state['Front Kit'] || option.dataset.front === state['Front Kit'])
        .map(option => axle === 'Front Kit' ? option.dataset.front : option.dataset.rear));
      const chooseAxle = (panel, configuration, rotor) => {
        const radios = [...panel.querySelectorAll('[data-pilot-configuration]')];
        const previous = radios.find(input => input.value === state[panel.dataset.pilotAxle]);
        const allowed = allowedConfigurations(panel.dataset.pilotAxle);
        const permitted = radios.filter(input => !input.hasAttribute('data-pilot-price-pending') && allowed.has(input.value));
        const physicalRotor = input => {
          const choice = eligibleChoices().find(option => (panel.dataset.pilotAxle === 'Front Kit' ? option.dataset.front : option.dataset.rear) === input.value);
          const hardware=choice && physicalHardware(choice)?.hardware?.[panel.dataset.pilotAxle === 'Front Kit'?'front':'rear'];
          return hardware ? hardware.diameter+'x'+hardware.thickness+' mm' : input.closest('[data-pilot-card]').dataset.rotor;
        };
        if(this._dustRequired && previous && !allowed.has(previous.value))dustPending.add(panel.dataset.pilotAxle);
        const requestedRotor=rotor || (dustPending.has(panel.dataset.pilotAxle)?rotorState[panel.dataset.pilotAxle]:null);
        let candidates=requestedRotor?permitted.filter(input=>physicalRotor(input)===requestedRotor):permitted;
        if(!candidates.length)candidates=permitted;
        const selected = candidates.find(input => input.value === configuration)
          || candidates.find(input => input.dataset.caliper === previous?.dataset.caliper)
          || candidates[0];
        state[panel.dataset.pilotAxle] = dustPending.has(panel.dataset.pilotAxle)?'':selected?.value || '';
        const selectedRotor = selected && physicalRotor(selected);
        rotorState[panel.dataset.pilotAxle]=selectedRotor;
        const caliperRotor = panel.querySelector('[data-pilot-caliper-rotor]');
        if (caliperRotor) caliperRotor.textContent = selectedRotor ? ' — ' + selectedRotor.replace('x', ' × ') : '';
        const rotorChoices=[...new Set(permitted.map(physicalRotor))].sort((a,b)=>parseInt(a)-parseInt(b)||a.localeCompare(b));
        panel.querySelectorAll('[data-pilot-rotor]').forEach((input,index) => {
          const usable = index < rotorChoices.length;
          if(usable){input.value=rotorChoices[index];input.closest('label').querySelector('.ceika-choice__body').textContent=input.value.replace('x',' × ');}
          input.closest('[data-pilot-rotor-choice]').hidden = !usable;
          input.disabled = !usable;
          input.checked = usable && input.value === selectedRotor;
        });
        panel.querySelectorAll('[data-pilot-card]').forEach(card => {
          const input = card.querySelector('input');
          const usable = allowed.has(input.value) && !input.hasAttribute('data-pilot-price-pending');
          card.hidden = !usable || physicalRotor(input) !== selectedRotor;
          input.disabled = !usable || physicalRotor(input) !== selectedRotor;
          input.checked = usable && input.value === state[panel.dataset.pilotAxle];
          const priced = eligibleChoices().find(option => (panel.dataset.pilotAxle === 'Front Kit' ? option.dataset.front : option.dataset.rear) === input.value);
          const cardLabel=card.querySelector('.ceika-choice__body strong');if(cardLabel)cardLabel.textContent=display(cardLabel.textContent);
          const price = card.querySelector('.ceika-choice__price');
          if (price && priced && mode !== 'Front + Rear') price.textContent = priced.dataset.price;
        });
      };
      const dustBox=document.createElement('div');dustBox.className='native-dust-filter';
      const dustNotice=document.createElement('p');
      dustNotice.dataset.dustFilterNotice='';dustNotice.setAttribute('role','status');dustNotice.tabIndex=-1;dustNotice.hidden=true;
      dustBox.append(dustNotice);dustBox.hidden=true;panels[0].before(dustBox);
      const refresh = () => {
        this.dataset.mode = mode;
        this.dataset.wheel = String(wheel);
        try {
          const selected = {};
          this.querySelectorAll('[data-pilot-configuration]:checked,[data-pilot-position]:checked,[data-pilot-parking-choice]:checked,[data-pilot-rotor]:checked').forEach(input => {
            selected[input.name || input.dataset.pilotConfiguration || input.dataset.pilotPosition || input.dataset.pilotParkingChoice || input.dataset.pilotRotor || input.value] = input.value;
          });
          sessionStorage.setItem('ceika_bbk_visualizer_setup', JSON.stringify({ value: wheel, mode, parking, kits: { front: state['Front Kit'], rear: state['Rear Kit'] }, selected, savedAt: Date.now() }));
        } catch (_) {}
        this.dispatchEvent(new CustomEvent('ceika:bbk-wheel-size', { bubbles: true, detail: { diameter: wheel } }));
        range.value = String(wheel);
        range.style.setProperty('--wheel-progress', ((wheel - 15) / 7 * 100) + '%');
        range.setAttribute('aria-valuetext', wheel + ' ' + this.dataset.inches);
        this.querySelector('[data-wheel-output]').textContent = wheel + '″';
        this.querySelector('[data-wheel-property]').value = wheel + '″';
        ticks.forEach(tick => tick.setAttribute('aria-pressed', String(Number(tick.dataset.wheelSize) === wheel)));
        positions.forEach(input => { input.checked = input.value === mode; });
        parkingChoices.forEach(input => { input.checked = input.value === parking; input.disabled = mode === 'Front Kit' || rearStatus.parkingChoiceDisabled; });
        panels.forEach(panel => {
          panel.hidden = mode !== 'Front + Rear' && mode !== panel.dataset.pilotAxle;
          if (!panel.hidden) chooseAxle(panel, state[panel.dataset.pilotAxle]);
        });
        this._dustPending=this._dustRequired && (mode==='Front + Rear'?['Front Kit','Rear Kit']:[mode]).some(axle=>dustPending.has(axle));
        if(this.extrasController)this.extrasController.engine.dustSelectionPending=this._dustPending;
        const eligible = eligibleChoices();
        dustBox.hidden=!this._dustRequired || (!this._dustPending && eligible.length>0);dustNotice.hidden=dustBox.hidden;
        dustNotice.textContent=!eligible.length?this._dustLabels.empty:this._dustPending?this._dustLabels.choose:this._dustLabels.active;
        if(this._dustIntent.environment)dustNotice.textContent+=' '+this._dustLabels.environment;
        const selected = eligible.find(option => (mode === 'Rear Kit' || option.dataset.front === state['Front Kit'])
          && (mode === 'Front Kit' || option.dataset.rear === state['Rear Kit']));
        this.querySelector('[data-wheel-count]').textContent = this.dataset.countLabel.replace('[count]', String(eligible.length)).replace('[wheel]', String(wheel));
        this.querySelector('[data-larger-fitment]').hidden = !choices.some(option => window.CeikaNativeOptions.kitAllowed(catalog, option.value) && option.dataset.position === mode && (fitment[option.value] || []).some(size => size > wheel) && !(fitment[option.value] || []).includes(wheel));
        this.querySelector('[data-pilot-empty]').hidden = !!selected || (this._dustRequired && eligible.length>0);
        this.querySelector('[data-pilot-build]').hidden = !selected;
        if (!selected) {
          if(!this._dustRequired)panels.forEach(panel => { panel.hidden = true; });
          variants.selectedIndex = -1;
          this.querySelector('[data-pilot-price]').textContent = '';
          this.querySelector('[data-pilot-option-two]').value = '';
          this.querySelector('[data-pilot-selection]').textContent = '';
          this.querySelectorAll('[data-pilot-included], [data-pilot-dust-included], [data-pilot-parking], [data-pilot-dust]').forEach(element => { element.hidden = true; });
        } else {
          variants.value = selected.value;
          this.querySelector('[data-pilot-option-two]').value = selected.dataset.configuration;
          this.querySelector('[data-pilot-selection]').textContent = display(selected.dataset.configuration.replace(' | Rear: ', '\nRear: '));
          this.querySelector('[data-pilot-price]').textContent = selected.dataset.price;
          this.querySelector('[data-pilot-included]').hidden = mode !== 'Front + Rear';
          this.querySelector('[data-pilot-dust-included]').hidden = mode !== 'Front + Rear' || selected.dataset.dust !== 'true';
          this.querySelector('[data-pilot-parking]').hidden = mode === 'Front Kit';
          parkingChoices.forEach(input => {
            const other = choices.find(option => option.dataset.position === mode && option.dataset.configuration === selected.dataset.configuration && option.dataset.parking === input.value);
            input.disabled = !other || mode === 'Front Kit' || rearStatus.parkingChoiceDisabled;
            this.querySelector('[data-parking-price="' + input.value + '"]').textContent = other?.dataset.price || '';
          });
          this.querySelector('[data-pilot-dust]').hidden = mode !== 'Front Kit' || selected.dataset.dust !== 'true';
        }
        const diameterTitle=this.closest('.ceika-product-pilot')?.querySelector('[data-ceika-bbk-diameters]');
        if(diameterTitle){
          const actual=selected?physicalHardware(selected)?.hardware:{};
          const diameterRows=['front','rear'].filter(axle=>Number.isFinite(actual?.[axle]?.diameter)).map(axle=>display(axle==='front'?'Front':'Rear')+' '+actual[axle].diameter+' mm');
          diameterTitle.textContent=diameterRows.length?' — '+diameterRows.join(' / '):'';
        }
        this.querySelector('[data-pilot-extras]').hidden = !selected && !this._dustRequired;
        this.querySelector('[data-pilot-total-row]').hidden = !selected;
        if (previousPricedVariant !== variants.value) {
          previousPricedVariant = variants.value;
          this.dataset.extrasPriceState = 'pending';
          this.querySelectorAll('[data-pilot-grand-total], [data-review-grand-total]').forEach(node => {
            node.textContent = this.dataset.pricePending;
          });
        }
        variants.dispatchEvent(new Event('input', { bubbles: true }));
        variants.dispatchEvent(new Event('change', { bubbles: true }));
        this.querySelectorAll('[data-pilot-review], [data-native-add]').forEach(button => { button.disabled = config.enabled !== true || config.connection?.purchaseEnabled !== true || !selected || this.dataset.extrasPriceState !== 'ready' || this.dataset.nativeError === 'true' || this.dataset.hardwareBlocked === 'true'; });
      };
      // Reuse the exact wheel/dust/parking eligibility used by the visible choices.
      this.getSuggestedKitCandidates = () => eligibleChoices().filter(option => {
        if(!Number.isFinite(basePrices.get(catalog.variantAliases[option.value]||option.value)))return false;
        return panels.filter(panel=>mode==='Front + Rear'||panel.dataset.pilotAxle===mode).every(panel=>{
          const value=panel.dataset.pilotAxle==='Front Kit'?option.dataset.front:option.dataset.rear;
          return [...panel.querySelectorAll('[data-pilot-configuration]')].some(input=>input.value===value&&!input.hasAttribute('data-pilot-price-pending'));
        });
      }).map(option=>({id:option.value,price:option.dataset.price,mode,hardware:physicalHardware(option)?.hardware||{},selected:variants.value===option.value&&!this._dustPending}));
      this.selectSuggestedKit = id => {
        if(!this.getSuggestedKitCandidates().some(row=>row.id===id))return false;
        const option=choices.find(row=>row.value===id);
        state['Front Kit']=option.dataset.front;state['Rear Kit']=option.dataset.rear;
        dustPending.clear();refresh();return true;
      };
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-wheel-range]')) return;
        wheel = Number(event.target.value);
        refresh();
      }, {signal:this._nativeAbort.signal});
      this.addEventListener('click', event => {
        const tick = event.target.closest('[data-wheel-size]');
        if (tick && this.contains(tick)) { wheel = Number(tick.dataset.wheelSize); refresh(); }
      }, {signal:this._nativeAbort.signal});
      this.addEventListener('change', event => {
        if(event.target.disabled)return;
        if (event.target.matches('[data-pilot-position]')) mode = event.target.value;
        else if (event.target.matches('[data-pilot-parking-choice]')) parking = event.target.value;
        else if (event.target.matches('[data-pilot-rotor]')) chooseAxle(event.target.closest('[data-pilot-axle]'), '', event.target.value);
        else if (event.target.matches('[data-pilot-configuration]')) {const panel=event.target.closest('[data-pilot-axle]');dustPending.delete(panel.dataset.pilotAxle);chooseAxle(panel,event.target.value);}
        else return;
        refresh();
      }, {signal:this._nativeAbort.signal});
      this.setDustRequirement=(requested,{notify=false,manual=false}={})=>{
        this._dustIntent[manual?'manual':'environment']=Boolean(requested);
        const required=this._dustIntent.manual||this._dustIntent.environment;
        const previousChoice=choices.find(o=>o.value===variants.value && (mode==='Front Kit'||o.dataset.parking===parking));
        this._dustRequired=required;
        if(!required)dustPending.clear();
        else if(previousChoice){
          const resolved=physicalHardware(previousChoice);
          for(const axle of mode==='Front + Rear'?['front','rear']:[mode==='Front Kit'?'front':'rear'])if(!resolved?.hardware?.[axle]?.dustSelected)dustPending.add(axle==='front'?'Front Kit':'Rear Kit');
        }
        const engine=this.extrasController?.engine;
        if(engine){engine.dustSelectionPending=dustPending.size>0;engine.setDustRequired(required);}
        refresh();
        this.dispatchEvent(new CustomEvent('ceika:dust-requirement',{detail:{required,manual,intent:{...this._dustIntent}}}));
        if(notify&&required&&this._dustPending)requestAnimationFrame(()=>{dustNotice.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});dustNotice.focus({preventScroll:true});});
      };
      this.restoreKit = saved => {
        const option = choices.find(o => o.value === saved.variantId);
        if (!option || !window.CeikaNativeOptions.kitAllowed(catalog,option.value)) throw new Error('edit_configuration_unavailable');
        mode = option.dataset.position; wheel = saved.wheel;
        parking = saved.parking ? 'Electronic E-brake' : 'No e-brake';
        state['Front Kit'] = option.dataset.front; state['Rear Kit'] = option.dataset.rear;
        dustPending.clear();
        const restoredHardware=window.CeikaFactoryPolicy.resolve({catalog,variant:catalog.baseVariants.find(v=>v.id===(catalog.variantAliases[option.value]||option.value)),parkingIncluded:parking!=='No e-brake',selected:{}});
        const savedBoots=saved.selected?.['boots-'+(mode==='Front + Rear'?'both':'single')];
        const optionalSaved=Object.values(restoredHardware.hardware||{}).some(row=>!row.dustCompulsory)&&savedBoots&& !String(savedBoots).startsWith('internal');
        this._dustIntent.manual=this._dustIntent.manual||saved.dustIntent?.manual===true||Boolean(optionalSaved);
        this._dustRequired=this._dustIntent.manual||this._dustIntent.environment;
        this.extrasController?.engine.setDustRequired(this._dustRequired);
        refresh();
        const canonical = id => catalog.variantAliases[id] || id;
        if (canonical(variants.value) !== canonical(saved.variantId)) throw new Error('edit_configuration_unavailable');
      };
      state['Front Kit'] = initial.dataset.front;
      state['Rear Kit'] = initial.dataset.rear;
      refresh();
      try { mountNativeOptions(this, catalog); window.CeikaPilotIntegrations?.attach(this); const lock=this.querySelector('[data-native-initialization-lock]');if(lock)lock.disabled=false; } catch(error) {
        this.dataset.nativeError = 'true';
        this.dataset.extrasPriceState = 'error';
        const labels = JSON.parse(this.querySelector('[data-native-labels]').textContent);
        this.querySelector('[data-pilot-extras]').textContent = labels.load_failed;
        this.querySelectorAll('[data-pilot-grand-total],[data-review-grand-total]').forEach(node=>{node.textContent=labels.price_unavailable;});
        this.querySelectorAll('[data-pilot-review], [data-native-add]').forEach(button => { button.disabled = true; });
        console.error('CEIKA native preview initialization failed',error);
      }
    }
    disconnectedCallback() { this._nativeAbort?.abort(); }
  });
}

})();



(function(global){
  'use strict';
  global.CeikaPilotIntegrations={attach(root){
    const signal=root._nativeAbort.signal;
    let financeTimer,attempts=0,garageBound=false,financeBound=false;
    const finance=root.querySelector('[data-native-affirm]');
    const financeWrapper=finance?.closest('[data-ceika-financing]');
    const hideFinance=()=>{
      clearTimeout(financeTimer);
      if(financeWrapper)financeWrapper.hidden=true;
      if(finance){finance.classList.remove('affirm-as-low-as');finance.removeAttribute('data-amount');finance.replaceChildren();}
    };
    const financeAmount=()=>{
      const engine=root.extrasController?.engine,catalog=engine?.catalog;
      if(signal.aborted || root.dataset.draftDesignReview==='true' || root.dataset.catalogueDraftPreview==='true' || root.dataset.priceLoadState!=='ready' || root.dataset.extrasPriceState!=='ready' || root.dataset.nativeError==='true' || root.dataset.hardwareBlocked==='true' || global.Shopify?.country!=='US' || catalog?.currency!=='USD' || catalog?.priceCountry!=='US' || catalog?.checkoutEnabled!==true)return null;
      try{const amount=engine.price().total;return Number.isSafeInteger(amount)&&amount>0?amount:null;}catch(_){return null;}
    };
    const updateFinance=()=>{
      const amount=financeAmount();
      if(!finance || amount===null){hideFinance();return;}
      if(Number(finance.dataset.amount)===amount && financeBound && finance.classList.contains('affirm-as-low-as'))return;
      finance.dataset.amount=String(amount);finance.classList.add('affirm-as-low-as');
      if(financeWrapper)financeWrapper.hidden=false;
      clearTimeout(financeTimer);
      financeTimer=setTimeout(()=>{
        if(financeAmount()!==amount){hideFinance();return;}
        if(global.affirm?.ui?.refresh)global.affirm.ui.refresh();
      },120);
    };
    hideFinance();
    signal.addEventListener('abort',hideFinance,{once:true});
    root.addEventListener('ceika:total',updateFinance,{signal});
    const connect=()=>{
      if(signal.aborted)return;
      const cm=global.Convermax;
      if(!garageBound && typeof cm?.getVehicleString==='function'){
        garageBound=true;
        const sync=()=>{
          if(signal.aborted)return;
          try{root.extrasController.setVehicle(String(cm.getVehicleString() || '').slice(0,200));}catch(_){}
        };
        // Chain existing handlers. Restore them on theme editor section unload.
        for(const key of ['onVehicleSelected','onVehicleRemoved']){
          const previous=cm[key];
          const handler=function(...args){try{if(typeof previous==='function')previous.apply(this,args);}finally{sync();}};
          cm[key]=handler;
          signal.addEventListener('abort',()=>{if(cm[key]===handler)cm[key]=previous;},{once:true});
        }
        sync();
        // Use the test product's actual identity; never claim another product's fitment.
        if(root.dataset.catalogueDraftPreview !== 'true' && root.dataset.draftDesignReview !== 'true'){try{cm.updateVerifyFitmentWidget?.(root.extrasController.engine.catalog.productId);}catch(_){}}
      }
      if(root.dataset.draftDesignReview !== 'true' && !financeBound && finance && global.affirm?.ui?.ready){
        financeBound=true;
        global.affirm.ui.ready(()=>{if(!signal.aborted){finance.removeAttribute('data-amount');updateFinance();}});
      }
      if((!garageBound || (root.dataset.draftDesignReview !== 'true' && finance && !financeBound)) && ++attempts<40)setTimeout(connect,500);
    };
    signal.addEventListener('abort',()=>clearTimeout(financeTimer),{once:true});
    updateFinance();connect();
  }};
})(window);










